import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import dayjs from "dayjs";
import { Box, Divider, Stack, Typography } from "@mui/material";

import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import HistoryIcon from "@mui/icons-material/History";

import { getTokenOrderById } from "src/api/tokenTransaction";

import font from "src/styles/font";
import { Grey, Red, White, White01 } from "src/styles/color";

import Button from "src/components/core/Button";

const Container = styled.div`
  width: 100%;
  height: calc(100dvh - 75px);
  max-width: 1240px;
  margin: 0 auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const WrapperInfo = styled(Box)`
  /* width: 100%; */
  min-width: 450px;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid ${White01};
  background-color: ${White};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px -1px rgba(0, 0, 0, 0.1);
`;

const FailedSection = () => {
  let [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [orderDetail, setOrderDetail] = useState(null);

  useEffect(() => {
    let orderId = searchParams.get("orderId");

    if (!orderId) return;

    const fetchOrderDetail = async () => {
      try {
        const data = await getTokenOrderById(orderId);
        setOrderDetail(data);
      } catch (error) {
        console.error("Error fetching order detail:", error);
      }
    };

    fetchOrderDetail();
  }, [searchParams]);

  return (
    <Container>
      <WrapperInfo>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 2,
            mb: 2,
            backgroundColor: "#FFE2E2",
            borderRadius: "50%",
          }}
        >
          <HighlightOffIcon sx={{ fontSize: 40, color: Red }} />
        </Box>

        <Typography variant="h5" fontWeight={600}>
          การชำระเงินไม่สำเร็จ
        </Typography>
        <Typography variant="body2" mt={1}>
          ขออภัย ไม่สามารถตัดเงินได้ในขณะนี้
        </Typography>
        <Typography variant="body2">
          กรุณาตรวจสอบข้อมูลการชำระเงินของคุณ
        </Typography>

        <Box
          sx={{
            backgroundColor: "#FEF2F2",
            borderRadius: 2,
            border: `1px solid #FFE2E2`,
            p: 2,
            mt: 6,
            mb: 4,
            width: "100%",
          }}
        >
          <Stack direction="row" gap={2}>
            <ErrorOutlineIcon sx={{ fontSize: 20, color: Red, mt: "2px" }} />

            <Stack>
              <Typography variant="subtitle1" color="#C10007" mb={0.5}>
                สาเหตุที่อาจเกิดขึ้น:
              </Typography>
              <Typography
                variant="body1"
                color="#E7000B"
                fontSize={font.size.sm}
                sx={{ ml: 2 }}
              >
                ยอดเงินในบัตรไม่เพียงพอ
              </Typography>
              <Typography
                variant="body1"
                color="#E7000B"
                fontSize={font.size.sm}
                sx={{ ml: 2 }}
              >
                ข้อมูลบัตรเครดิตไม่ถูกต้อง
              </Typography>
              <Typography
                variant="body1"
                color="#E7000B"
                fontSize={font.size.sm}
                sx={{ ml: 2 }}
              >
                ธนาคารปฏิเสธการทำรายการ
              </Typography>
            </Stack>
          </Stack>

          <Divider sx={{ my: 1.5, borderColor: "#FFE2E2" }} />

          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            gap={2}
          >
            <Typography variant="body1" color="#E7000B" fontSize={font.size.sm}>
              รหัสอ้างอิง: ERR_PAYMENT_DECLINED
            </Typography>

            <Typography variant="body1" color="#E7000B" fontSize={font.size.sm}>
              {dayjs(orderDetail?.createdAt).format("DD/MM/YYYY HH:mm")}
            </Typography>
          </Stack>
        </Box>

        <Button
          variant="contained"
          fullWidth
          startIcon={<HistoryIcon />}
          onClick={() => navigate("/seller-token-order")}
        >
          ไปที่หน้าประวัติการสั่งซื้อ
        </Button>

        <Typography variant="body2" mt={3} fontSize={font.size.sm} color={Grey}>
          หากพบปัญหา กรุณาติดต่อทางไลน์ @xsfseller
        </Typography>
      </WrapperInfo>
    </Container>
  );
};

export default FailedSection;
